import type { InsuranceListResponse } from "@/features/insurance/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function getInsuranceList(): Promise<InsuranceListResponse> {
  return patientRequestsTyped.get_insurance_list({ context: { showLoader: false } });
}
